var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCounterClockwiseArrow = function SvgCounterClockwiseArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 .25a.75.75 0 0 1 .75.75v4.88a27.049 27.049 0 0 1 1.863-1.928C5.503 2.188 8.19.25 11 .25c3.806 0 6.023 1.927 7.256 3.844a10.661 10.661 0 0 1 1.47 3.697l.012.071.003.021v.007l.001.002v.001L19 8l.742-.106a.75.75 0 0 1-1.484.214v-.001l-.002-.01a8.526 8.526 0 0 0-.238-.97 9.168 9.168 0 0 0-1.024-2.221C15.977 3.323 14.194 1.75 11 1.75c-2.19 0-4.503 1.562-6.363 3.298A25.98 25.98 0 0 0 2.55 7.25H8a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 8V1A.75.75 0 0 1 1 .25Z",
    fill: "#050400"
  })));
};
export default SvgCounterClockwiseArrow;